<template lang="pug">
	.asset-image-generation-settings
		.form-line.model
			.form-group
				.field-title Vendor
				InputSelect(v-on:change="setVendor($event)" :default="vendorCodename" :value="vendorCodename" :values="vendors" :options="{editable: false, dropdownWidth: 174, displayedValueTransform: v => Metadata.AIVendorsByCodename[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group
				.field-title Model
				InputSelect(v-on:change="setModel($event)" :default="modelCodename" :value="modelCodename" :values="models" :options="{editable: false, dropdownWidth: 174, dropdownHeight: 400, displayedValueTransform: v => Metadata.AIModelsByHierarchy[vendorCodename]?.[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group.style
				.field-title Style
				MultiSelect(v-on:change="setStyle($event)" :default="styleCodenames" :value="styleCodenames" :values="styles" :options="{dropdownWidth: 174, dropdownHeight: 400, displayedValueTransform: v => Metadata.AIStylesByHierarchy[vendorCodename]?.[modelCodename]?.[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group
				.field-title
					span Size
					span.attached-images(v-if="sizeCodename === null && attachmentsCount > 0" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'With Size = Auto the output size matches the original (or first attached) image'}") = reference
				InputSelect(v-on:change="setSize($event)" :default="sizeCodename" :value="sizeCodename" :values="sizes" :options="{editable: false, dropdownWidth: 174, dropdownHeight: 400, displayedValueTransform: v => Metadata.AISizesByHierarchy[vendorCodename]?.[modelCodename]?.[v]?.title || (v === null ? 'Auto' : '')}" :disabled="!!readOnly" theme="dark-medium")
			.form-group.count
				.field-title Count
				InputSelect(v-on:change="setCount($event)" :default="count" :value="count" :values="counts" :options="{editable: false, dropdownWidth: 50}" :disabled="!!readOnly || !prompt" theme="dark-medium")
			.form-group.setups
				.field-title Btn
				.setups-button(v-if="readOnly !== true" @click="openSetups($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Presets'}")
					i.fa.fa-bars
		.form-line.separator.post-processing
			.no-background
				InputSwitch(:default="removeBackground" :value="removeBackground" @input="setRemoveBackground($event)" theme="colour-medium")
				span Remove background (create transparent sprite)
		.form-line.separator.prompt
			.form-group
				.field-title
					.title
						span Image generation prompt
						span.attached-images(v-if="attachmentsCount === 1") +1 reference image
						span.attached-images(v-else-if="attachmentsCount > 1") +{{attachmentsCount}} reference images
					.history-button(v-if="readOnly !== true" @click="openPromptsHistory($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Prompts history'}")
						i.fa.fa-bars
				textarea(:disabled="!!readOnly" placeholder="A majestic cat in the snow" v-model="prompt" @input="updateSettings")
			//.form-group.auto-prompt
				.field-title
					.auto-prompts-selector(v-if="readOnly !== true" @click="openPromptsProposals($event)")
						i.fa.fa-bars
					span Automatic prompt enhancement
				textarea(disabled)
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import InputSelect			from './../Editor/Controls/InputSelect'
	import MultiSelect			from './../Editor/Controls/MultiSelect'
	import InputSwitch			from './../Editor/Controls/InputSwitch'

	export default {
		name: "AssetImageGenerationSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed"
			],
			events: {
			}
		},
		props: ['creative', 'asset', 'readOnly'],
		components: {
			InputSelect,
			MultiSelect,
			InputSwitch
		},
		data() {

			this.variations = [];

			this.vendors = [];
			this.models = [];
			this.styles = [];
			this.sizes = [];
			this.counts = [];

			return {
				showed: true,
				// По умолчанию генерация идёт через OpenRouter моделью Nano Banana 2, а фон у спрайтов удаляет Leonardo
				vendorCodename: "openrouter",
				modelCodename: "nano-banana-2",
				styleCodenames: ["none"],
				sizeCodename: null,
				removeBackground: false,
				prompt: '',
				promptEnhancement: '',
				attachmentsCount: 0,
				count: 1
			}

		},
		methods: {
			collectData() {

				// Вендоры, у которых есть модели генерации картинок
				let imageVendorCodenames = _.uniq(_.map(_.filter(Metadata.AIModels, aiModel => aiModel.type === 'image'), 'vendor_codename'));

				this.vendors = _.map(_.filter(Metadata.AIVendors, vendor => imageVendorCodenames.includes(vendor.codename)), vendor => {
					return {..._.pick(vendor, ['title', 'description']), data: {itemValue: vendor.codename}}
				});

				// У каждого вендора свои модели: если у вендора нет сохранённой модели, берём первую активную
				// В окне генерации картинок доступны только модели картинок (видео-модели выбираются в окне генерации видео)
				let models = _.pickBy(Metadata.AIModelsByHierarchy[this.vendorCodename], aiModel => aiModel.type === 'image');

				if (!models?.[this.modelCodename]) {

					let model = _.find(models, {active: 1}) || _.head(_.values(models));

					this.modelCodename = model?.codename || this.modelCodename;

				}

				this.models = _.map(models, model => {
					return {..._.pick(model, ['title']), description: `by ${model.developer}`, disabled: !model.active, data: {itemValue: model.codename}}
				});

				// У каждой модели свои стили: оставляем только доступные ей, а если ни один не доступен - берём стиль по умолчанию или первый
				let styles = Metadata.AIStylesByHierarchy[this.vendorCodename]?.[this.modelCodename];

				this.styleCodenames = _.filter(this.styleCodenames, styleCodename => styles?.[styleCodename]);

				if (!this.styleCodenames.length) {

					let style = styles?.["dynamic"] || _.head(_.values(styles));

					this.styleCodenames = style ? [style.codename] : [];

				}

				this.styles = _.map(styles, style => {
					return {..._.pick(style, ['title', 'description']), data: {itemValue: style.codename}}
				});

				this.sizes = _.map(Metadata.AISizesByHierarchy[this.vendorCodename]?.[this.modelCodename], size => {
					return {..._.pick(size, ['title', 'description']), data: {itemValue: size.codename}}
				});

				this.sizes.splice(0, 1, {title: 'Auto', data: {itemValue: null}});

				this.model = models[this.modelCodename];

				let maxCount = this.model?.options?.maxCount || 1;

				this.counts = [];
				for (let i=0; i<maxCount; i++) this.counts.push({title: i+1, data: {itemValue: i+1}});

				if (this.count > maxCount) this.count = maxCount;

			},
			setVendor(vendorCodename) {

				this.vendorCodename = vendorCodename;

				// У каждого вендора свои модели, стили и размеры - список настроек пересобирается
				this.collectData();

				this.updateSettings();

			},
			setModel(modelCodename) {

				this.modelCodename = modelCodename;

				// У каждой модели свои стили и размеры - список настроек пересобирается
				this.collectData();

				this.updateSettings();

			},
			setStyle(styleCodenames) {

				this.styleCodenames = styleCodenames;

				this.updateSettings();

			},
			setSize(sizeCodename) {

				this.sizeCodename = sizeCodename;

				this.updateSettings();

			},
			setCount(count) {

				this.count = count;

				this.updateSettings();

			},
			setRemoveBackground(removeBackground) {

				this.removeBackground = removeBackground;

				this.updateSettings();

			},
			setPrompt(prompt) {

				this.prompt = prompt;

				this.updateSettings();

			},
			updateSettings() {

				this.$emit("change", this.getSettings());

			},
			setSettings(settings) {

				if ("vendorCodename" in settings) this.vendorCodename = settings.vendorCodename;
				if ("modelCodename" in settings) this.modelCodename = settings.modelCodename;
				if ("styleCodenames" in settings) this.styleCodenames = settings.styleCodenames;
				if ("sizeCodename" in settings) this.sizeCodename = settings.sizeCodename || null;
				if ("count" in settings) this.count = settings.count;
				if ("removeBackground" in settings) this.removeBackground = !!settings.removeBackground;
				if ("prompt" in settings) this.prompt = settings.prompt;
				if ("promptEnhancement" in settings) this.promptEnhancement = settings.promptEnhancement;

				// Настройки могли быть установлены для другого вендора и модели - пересобираем списки и сообщаем об изменениях
				this.collectData();

				this.updateSettings();

			},
			getSettings() {

				return {
					vendorCodename: this.vendorCodename,
					modelCodename: this.modelCodename,
					styleCodenames: this.styleCodenames,
					sizeCodename: this.sizeCodename,
					count: this.count,
					removeBackground: this.removeBackground,
					prompt: this.prompt,
					promptEnhancement: this.promptEnhancement
				}

			},
			setAttachmentsCount(attachmentsCount) {

				this.attachmentsCount = attachmentsCount;

				this.update();

			},
			openSetups(e) {

				// Пресеты меняют только удаление фона: вендор, модель и стиль остаются выбранными пользователем
				let items = [
					{title: "Transparent sprite", data: {removeBackground: true}},
					{title: "Background image", data: {removeBackground: false}}
				];

				Broadcast.call("Show InputSelectDropdown", [e.currentTarget, items, {
					value: items[0].title,
					width: 200,
					header: {title: 'Presets', description: 'Select from this list what you need to do to quickly set up the appropriate settings'},
					autoClose: true,
					callback: (data) => {

						this.setSettings(data);

					}
				}]);

			},
			openPromptsHistory(e) {

				let assetPrompts = _.filter(Asset.Generations, generation => generation["creative_id"] === this.creative.id && generation["asset_codename"] === this.asset?.codename && _.trim(generation.prompt));
				assetPrompts = _.uniqBy(assetPrompts, "prompt");

				let creativePrompts = _.filter(Asset.Generations, generation => (generation["creative_id"] === this.creative.id) && _.trim(generation.prompt));
				creativePrompts = _.uniqBy(creativePrompts, "prompt");

				let userPrompts = _.filter([...Asset.UserGenerationPrompts, ..._.filter(Asset.Generations, generation => (generation["user_id"] === User.currentUser.id))], gen => _.trim(gen.prompt));

				userPrompts = _.uniqBy(userPrompts, "id");
				userPrompts = _.uniqBy(userPrompts, "prompt");

				let items = [
					{title: "Asset level prompts", width: 250, childs: _.map(assetPrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Creative level prompts", width: 250, childs: _.map(creativePrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Your previous prompts", width: 250, childs: _.map(userPrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Prompt examples", width: 200, childs: [
						{title: "Background image for the casino slot mobile game", data: {itemValue: "Background image for the casino slot mobile game"}, wordWrap: true}
					]},
				];

				Broadcast.call("Show InputSelectDropdown", [e.currentTarget, items, {
					value: items[0].title,
					header: {title: 'Prompts history', description: 'Select previous prompts from these lists'},
					autoClose: true,
					callback: (data) => {

						this.setPrompt(data.itemValue);

					}
				}]);

			},
			openPromptsProposals(e) {

				let items = [
					//{title: "Element name"},
					//{title: "Creative name"},
					//{title: "Settings proposal"},
				];

				if (this.asset)
					items.push({title: "Image name", description: this.asset.codename.split('.')[0]});

				if (this.creative?.type === 'playable')
					items.push({title: "Creative type", description: "For the playable ads"});
				if (this.creative?.type === 'banner')
					items.push({title: "Creative type", description: "For the web mobile banner"});

				items.push({title: "Mobile game", description: "For the mobile game"});

				Broadcast.call("Show InputSelectDropdown", [e.currentTarget, items, {value: items[0].title, callback: (data) => {

					this.toggleValue(data.itemValue);

				}}]);

			}
		}
	}
</script>

<style lang="sass">

	.asset-image-generation-settings
		display: flex
		flex-direction: column

		.attached-images
			color: var(--orange)
			margin-left: 10px

		.form-line
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.model
			margin-bottom: 10px

			.form-group
				margin-right: 10px

			.field-title
				margin-left: 1px

			.form-group.style

				.multi-select-control

					label
						width: 250px

					input
						width: 235px

			.form-group.count

				.input-select-control
					width: 50px

			.form-group.setups
				margin-left: auto
				margin-right: 0

				.field-title
					visibility: hidden

				.setups-button
					cursor: pointer
					padding: 5px 6px
					transition: color 0.2s
					color: var(--gray)

					&:hover
						color: var(--primary)

		.prompt

			.form-group
				width: 100%

			textarea
				//width: 444px
				height: 85px
				resize: none
				background-color: #515b65
				border: 1px solid #23282c
				border-radius: 0.2rem
				color: white
				padding: 0.3rem
				font-size: 0.9rem
				margin-bottom: 0px
				outline: none

			textarea::placeholder
				color: rgba(255,255,255,0.1)

			.field-title
				display: flex
				flex-direction: row
				align-items: center
				justify-content: space-between
				margin-left: 2px

				.history-button, .auto-prompts-selector
					cursor: pointer
					padding: 0px 5px
					transition: color 0.2s

					&:hover
						color: var(--primary)

			.auto-prompt
				margin-left: 10px

			.attached-images
				color: var(--orange)
				margin-left: 10px

		.post-processing
			margin-bottom: 10px
			padding-bottom: 10px !important

			.no-background
				display: flex
				flex-direction: row
				align-items: center

				.editor-control-input-switch
					margin-right: 10px

</style>

